"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".mobile-wrap .buyBaner h1{text-align:center}.mobile-wrap .buyBaner .row{display:block}.mobile-wrap .buyBaner .d-flex{display:flex;flex-wrap:wrap;align-items:center;margin-bottom:10px}.mobile-wrap .buyBaner .securityPaymentInformation{width:100%;margin-bottom:10px}.mobile-wrap .buyBaner .mat-radio-button:not(:first-child){padding-left:15px}.mobile-wrap .buyBaner input[type=file]{padding:0!important}.mobile-wrap .buyBaner button[type=submit]{width:100%}"];
exports.styles = styles;
